/**
 * @ngdoc service
 * @name billing.position_categories.factory:PositionCategorys
 *
 * @description
 *
 */
angular
    .module('festzelt-os.billing.position_categories')
    .factory('PositionCategory', [
        '$translate',
        'Resource',
        PositionCategory
    ]);

function PositionCategory($translate, Resource) {
    var $model = Resource.make('billing/positions/categories');
    $model.title = 'Position Categories';

    $model.schema = {
        type: 'object',
        title: $translate.instant('billing.position_categories.title'),
        properties: {
            id: {
                title: $translate.instant('billing.position_categories.labels.id'),
                type: 'number',
                listview: 'hidden',
                mergeable: false
            },
            title: {
                title: $translate.instant('billing.position_categories.labels.title'),
                type: 'string',
                columnDef: {
                    main: true
                }
            }
        }
    };


    $model.form = [
        'title'
    ];

    return $model;
}



// WEBPACK FOOTER //
// ./src/app/pages/billing/position_categories/factories/position_category-factory.js